<div class="container">
  <h4>Camera Site</h4>
  <form #siteform="ngForm" (ngSubmit)="siteform.form.valid && saveSite()">
    <div class="row row-cols-1 row-cols-md-3">
      <div class="col mb-3">
        <label for="txtName">Site Name</label
        ><input
          #txtName="ngModel"
          type="text"
          name="txtName"
          id="txtName"
          class="form-control"
          [(ngModel)]="siteModel.Name"
          [disabled]="!isReady"
          required />
        @if (
          ((txtName.dirty && txtName.touched) || siteform.submitted) &&
          txtName.errors?.required
        ) {
          <small class="text-danger">Site Name required</small>
        }
      </div>
      <div class="col mb-3">
        <label for="txtServer">Server Name</label
        ><input
          #txtServer="ngModel"
          type="text"
          name="txtServer"
          id="txtServer"
          class="form-control text-uppercase"
          [(ngModel)]="siteModel.CameraServerName"
          [disabled]="!isReady"
          required />
        @if (
          ((txtServer.dirty && txtServer.touched) || siteform.submitted) &&
          txtServer.errors?.required
        ) {
          <small class="text-danger">Server Name required</small>
        }
      </div>
      <div class="col mb-3">
        <label for="cboDomain">Server Domain</label
        ><select
          #cboDomain="ngModel"
          name="cboDomain"
          id="cboDomain"
          class="form-control form-select"
          [(ngModel)]="siteModel.Domain"
          [disabled]="!isReady">
          <option value="na.valmont.com">na.valmont.com</option>
          <option value="as.valmont.com">as.valmont.com</option>
        </select>
      </div>
    </div>
    <div class="row row-cols-1 row-cols-md-4">
      <div class="col mb-3">
        <label for="txtPort">Service Port</label>
        <input
          #txtPort="ngModel"
          [(ngModel)]="siteModel.ServicePort"
          [disabled]="!isReady"
          name="txtPort"
          placeholder=""
          type="number"
          class="form-control"
          required />
        @if (
          ((txtPort.touched && txtPort.dirty) || siteform.submitted) &&
          txtPort.errors?.required
        ) {
          <small class="text-danger"
            >Service Port is required, use 0 if N/A</small
          >
        }
      </div>
      <div class="col mb-3">
        <label for="txtMobilePort">Mobile Port</label>
        <input
          #txtMobilePort="ngModel"
          [(ngModel)]="siteModel.MobilePort"
          [disabled]="!isReady"
          name="txtMobilePort"
          placeholder=""
          type="number"
          class="form-control"
          required />
        @if (
          ((txtMobilePort.touched && txtMobilePort.dirty) ||
            siteform.submitted) &&
          txtMobilePort.errors?.required
        ) {
          <small class="text-danger"
            >Mobile Port is required, use 0 if N/A</small
          >
        }
      </div>
      <div class="col mb-3">
        <label for="cboCred">Server Credential</label
        ><select
          #cboCred="ngModel"
          name="cboCred"
          id="cboCred"
          class="form-control form-select"
          [(ngModel)]="siteModel.CredentialId"
          [disabled]="!isReady">
          @for (cred of this.adminService.serverCredentials; track cred) {
            <option [ngValue]="cred.Id">
              {{ cred.Name }}
            </option>
          }
        </select>
      </div>
      <div class="d-flex col align-items-center">
        <div class="form-check form-switch custom-switch-info">
          <input
            #chkACS="ngModel"
            type="checkbox"
            class="form-check-input"
            id="chkACS"
            name="chkACS"
            [(ngModel)]="siteModel.IsAcs" />
          <label class="form-check-label" for="chkACS"
            >Axis Camera Station</label
          >
        </div>
      </div>
    </div>
    <div class="row row-cols-1 row-cols-md-2">
      <div class="col"></div>
      <div class="text-end col">
        @if (!isNew) {
          <button
            (click)="deleteSite()"
            type="button"
            [disabled]="!isReady || !adminService.isReady"
            class="btn btn-outline-danger btn-sm me-1">
            Delete
          </button>
        }
        <button
          type="button"
          [disabled]="!isReady"
          [routerLink]="['/admin', 'sites']"
          class="btn btn-sm btn-secondary">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="!isReady || !adminService.isReady"
          class="btn btn-sm btn-primary ms-1">
          Save
        </button>
      </div>
    </div>
  </form>

  <div class="p-1">
    <ngb-alert type="info" [hidden]="isReady" [dismissible]="false" class="">
      <fa-icon animation="spin-pulse" [icon]="icons.spinner"></fa-icon>
      {{ this.alertMsg }}
    </ngb-alert>
  </div>

  <ul ngbNav #siteNav="ngbNav" class="nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink
        >Cameras
        <span class="badge bg-success">{{
          this.siteModel.Cameras.length
        }}</span>
      </a>
      <!-- Camera Listing -->
      <ng-template ngbNavContent>
        <div
          class="p-1"
          style="
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;
          ">
          <h5>Cameras</h5>
          <button
            (click)="exportCameras()"
            title="Export Cameras"
            class="btn btn-outline-info btn-sm">
            <fa-icon [icon]="icons.download"></fa-icon>
            Export
          </button>
        </div>
        <table class="table table-sm table-striped table-hover table-hover">
          <thead class="table-dark">
            <tr>
              <th></th>
              <th>Name (edit)</th>
              <th class="d-none d-md-table-cell">IP Address</th>
              <th class="d-none d-md-table-cell">Resolution</th>
              <th class="d-none d-md-table-cell">Model</th>
              <th class="d-none d-md-table-cell">Service Date</th>
              <th class="d-none d-lg-table-cell">Last Sync</th>
            </tr>
          </thead>
          <tbody>
            @for (camera of siteModel.Cameras; track camera; let i = $index) {
              <tr>
                <td>
                  @if (camera.HasError) {
                    <fa-icon
                      [icon]="icons.exclamation"
                      class="text-danger"
                      title="{{ camera.ErrorMessage }}"></fa-icon>
                  } @else if (!camera.HasError) {
                    <fa-icon
                      [icon]="icons.video"
                      class="text-success"></fa-icon>
                  } @else {
                    <fa-icon
                      [icon]="icons.spinner"
                      animation="spin-pulse"
                      class="text-muted"
                      title="Checking camera..."></fa-icon>
                  }
                </td>
                <td
                  class="table-cell-detail"
                  (click)="editCamera(i)"
                  title="Click to edit">
                  {{ camera.Name }}
                </td>
                <td class="d-none d-md-table-cell">
                  <a href="http://{{ camera.IpAddress }}" target="_blank">{{
                    camera.IpAddress
                  }}</a>
                </td>
                <td class="d-none d-md-table-cell">{{ camera.Resolution }}</td>
                <td class="d-none d-md-table-cell">{{ camera.Model }}</td>
                <td class="d-none d-lg-table-cell">
                  {{ camera.ServiceDate | date: 'MM/dd/yyyy' }}
                </td>
                <td class="d-none d-lg-table-cell">
                  {{ camera.LastSync | date: 'short' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </ng-template>
    </li>
    <li ngbNavItem>
      <a ngbNavLink
        >Users
        <span class="badge bg-success">{{ this.selectedUsers.length }}</span></a
      >
      <!-- User Selection -->
      <ng-template ngbNavContent>
        <app-user-picker
          caption="Users"
          [(isReady)]="isReady"
          [(users)]="allUsers">
        </app-user-picker>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="siteNav" class="p-2 border"></div>
</div>
